import { render, staticRenderFns } from "./PerAgent.vue?vue&type=template&id=f20ab108&"
import script from "./PerAgent.vue?vue&type=script&lang=js&"
export * from "./PerAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports